import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Tours from "../pages/tours/page";
import Gallery from "../pages/gallery/page";
import Testimonials from "../pages/testimonials/page";
import Contact from "../pages/contact/page";
import Certifications from "../pages/certifications/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/tours",
    element: <Tours />,
  },
  {
    path: "/gallery",
    element: <Gallery />,
  },
  {
    path: "/testimonials",
    element: <Testimonials />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/certifications",
    element: <Certifications />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
